import { useCartOrderTypeRefresh } from '~/composables/useCartOrderTypeRefresh'
import { useSearchApplication } from '~/composables/useSearchApplication'

export default defineNuxtPlugin(() => {
  const { searchStore } = useSearchApplication()
  useCartOrderTypeRefresh(() => searchStore.orderType)
})
